import { routeInfo } from '../../../../routeInfo';
import * as React from 'react';
import { connect, ConnectedProps, Provider } from 'react-redux';
import history from '../../../../history';
import * as _ from 'lodash';
import * as actions from '../../../../redux/projects/actions.projects';
import * as diffModeActions from '../../../../redux/diffMode/actions.diffMode';
import * as microphoneActions from '../../../../redux/microphone/actions.microphone';
import * as scriptEditorActions from '../../../../redux/scriptEditor/actions.scriptEditor';
import tierMessages from '../../../../const/tierMessages';
import getAvailableFeatures from '../../../../services/mini/getAvailableFeatures';
import getProjectId from '../../../../services/mini/getProjectId';
import ToasterService from '../../../../services/ToasterService';
import ComboBox from '../../../components/ComboBox/ComboBox';
import EnvironmentItem from '../../../components/EnvironmentItem/EnvironmentItem';
import UserInfo from '../../../headers/UserInfo/UserInfo';
import HeaderNavigation from '../../../headers/HeaderNavigation/HeaderNavigation';
import PageHeader from '../../../headers/PageHeader/PageHeader';
import { isCiCdTag } from '../../../../services/mini/isCiCdTag';
import HeaderPartSeparator from '../../../headers/HeaderPartSeparator/HeaderPartSeparator';
import getBaseUrl from '../../../../services/mini/getBaseUrl';
import makeUrl from '../../../../services/mini/makeUrl';
import ProjectHeaderButton from './ProjectHeaderButton';
import getArrayHash from '../../../../services/mini/getArrayHash';
import servers from '../../../../const/servers';
import canChangeEnvironment from '../../../../services/mini/canChangeEnvironment';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import { Environment } from '../../../../const/environment';
import ProjectTagSelector from '../ProjectTagSelector/ProjectTagSelector';
import CreateOrSwitchToLastTagBtn from '../CreateOrSwitchToLastTagBtn/CreateOrSwitchToLastTagBtn';
import copyTextToBuffer from '../../../../services/mini/copyTextToBuffer';
import { IChangeEnvironmentParam } from '../../../../redux/projects/saga.projects';
import { ProjectViewMode } from '../../../../const/projectViewMode';
import CrawlerInspector from '../CrawlerInspector/CrawlerInspector';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import store from '../../../../store';
import Overlay from '../../../components/Overlay/Overlay';


type ProjectHeaderProps = ProjectHeaderReduxProps & {
  environment: Environment
  hasProjectsData: boolean
  selectedStageTagId: string
  projectMode: string
  changeEnvironment: (param: IChangeEnvironmentParam) => void
}

type ProjectHeaderState = {
  isCrawlerInspectorShown: boolean
}

class ProjectHeader extends React.Component<ProjectHeaderProps, ProjectHeaderState> {

  constructor(props, context) {

    super(props);

    this.state = {
      isCrawlerInspectorShown: false
    };

  }

  shouldComponentUpdate(nextProps, nextState) {
    var curProps = this.props;
    var curState = this.state;

    if (curState.isCrawlerInspectorShown !== nextState.isCrawlerInspectorShown) {
      return true;
    }

    if (curProps.scriptName !== nextProps.scriptName ||
      curProps.environment !== nextProps.environment ||
      curProps.projectMode !== nextProps.projectMode ||
      curProps.hasProjectsData !== nextProps.hasProjectsData ||
      curProps.githubDeployId !== nextProps.githubDeployId ||
      curProps.selectedStageTagId !== nextProps.selectedStageTagId) {
      return true;
    }

    if (curProps.project && nextProps.project) {
      if (
        (curProps.project.stageTagId !== nextProps.project.stageTagId) ||
        (curProps.project.prodTagId !== nextProps.project.prodTagId) ||
        (curProps.project.testTagId !== nextProps.project.testTagId) ||
        (curProps.project.updateTs !== nextProps.project.updateTs) ||
        (curProps.project.tags && nextProps.project.tags &&
          getArrayHash(curProps.project.tags, ['message']) !== getArrayHash(nextProps.project.tags, ['message'])) ||
        (curProps.project.scripts && nextProps.project.scripts &&
          getArrayHash(curProps.project.scripts, ['scriptId']) !== getArrayHash(nextProps.project.scripts, ['scriptId'])) ||
        (curProps.project.conversations && nextProps.project.conversations &&
          getArrayHash(curProps.project.conversations, ['id']) !== getArrayHash(nextProps.project.conversations, ['id']))
      ) {
        return true;
      }
    }

    return false;
  }

  openDemo = () => {
    const {
      environment,
      project,
      userEmail
    } = this.props;

    const key = `${project.projectId}/${environment}`;
    const demoUrl = `${getBaseUrl()}/web/alan_example.html?key=${makeUrl(key)}&projectName=${makeUrl(project.name)}&projectOwner=${makeUrl(userEmail)}&backUrl=${window.location.href}`;
    const win = window.open(demoUrl, '_blank');
    win.focus();
  }

  changeEnvironment = (environmentObj) => {
    const { project, environment, tier, changeEnvironment } = this.props;
    const newEnvironment = environmentObj.key;

    if (newEnvironment === environment) {
      return;
    }

    if (canChangeEnvironment(tier, newEnvironment)) {
      changeEnvironment({ project, environment: newEnvironment });
    }
  }

  copyScript = () => {
    const { project, scriptName } = this.props;
    const currentScript = _.find(project.scripts, { name: scriptName });
    if (currentScript) {
      copyTextToBuffer(currentScript.text);
      ToasterService.showInfo({ title: "Script content was copied to buffer" });
    }
  }

  showSourceCodePopup = () => {
    const { projectName, scriptName } = this.props;
    history.push(routeInfo.embed.url(projectName, scriptName));
  }

  compareVersions = () => {
    const
      {
        openDiffModeAction,
        projectName,
        scriptName
      } = this.props;
    openDiffModeAction({ projectName, scriptName });
  }

  showCrawlerInspector = () => {
    const { project } = this.props;

    if (!project?.projectId) return;

    this.setState({ isCrawlerInspectorShown: true });

  }

  showAnalytics = () => {
    const { projectName, scriptName } = this.props;
    history.push(routeInfo.analytics.url(projectName, scriptName));
  }

  changeProjectMode = (mode) => {
    const {
      project,
      projectName,
      scriptName,
      changeProjectTestMode
    } = this.props;

    changeProjectTestMode({
      projectId: project.projectId,
      projectName: projectName,
      scriptName: scriptName,
      mode: mode
    });
  }

  changeProjectModeToEdit = () => {
    this.changeProjectMode(ProjectViewMode.Edit);
  }

  changeProjectModeToTest = () => {
    const availableFeatures = getAvailableFeatures(this.props.tier);

    if (!availableFeatures.modes.includes(ProjectViewMode.Test)) {
      ToasterService.showInfo({
        title: tierMessages.testModeIsUnavailable,
        onlyUserCanHide: true
      });
      return;
    }

    this.changeProjectMode(ProjectViewMode.Test);
  }

  render() {
    const {
      projectName,
      scriptName,
      project,
      environment,
      projectMode,
      githubDeployId,
      features,
      projectId,
      highlightLine,
      fontSize,
      codeTheme
    } = this.props;

    const { isCrawlerInspectorShown } = this.state;

    const tagsWoCiCd = project?.tags?.filter((tag) => {
      return !isCiCdTag(tag);
    }) || [];

    const compareVersionsBtn = {
      id: 'compareTooltip',
      tip: 'Compare',
      tooltipClass: 'compare-link-tooltip',
      className: `small-square-btn compare-link ${tagsWoCiCd.length <= 1 && 'disabled'}`,
      onClick: this.compareVersions,
      iconClass: 'icon-compare-version'
    };

    const projectButtons = [
      {
        id: 'crawlerTooltip',
        tip: 'Crawler Tasks',
        tooltipClass: 'project-crawler-link-tooltip',
        className: "small-square-btn crawler-link",
        onClick: this.showCrawlerInspector,
        iconClass: 'icon-alan-stat-browser'
      },
      features?.analytics?.enabled === true ?
        {
          id: 'analyticsTooltip',
          tip: 'Analytics',
          tooltipClass: 'project-analytics-link-tooltip',
          className: "small-square-btn analytics-link",
          onClick: this.showAnalytics,
          iconClass: 'icon-analytics'
        } : null,
      {
        id: 'demoLinkTooltip',
        tip: 'Playground',
        tooltipClass: 'demo-link-tooltip',
        className: "small-square-btn demo-link",
        onClick: this.openDemo,
        iconClass: 'icon-alan-demo-playground'
      },
    ].filter(el => !!el);

    const selectedTagId = project[`${environment}TagId`];
    const hasSelectedTag = project && project.tags && project.tags.length > 0 && selectedTagId;
    const isCiCd = githubDeployId !== '';

    return (
      <PageHeader
        leftPart={
          <React.Fragment>
            <HeaderNavigation projectName={projectName} project={project} />
            <React.Fragment>
              <div className="project-header">
                <div className="project-header_left">
                  <HeaderPartSeparator height={32} marginLeft={4}
                    marginRight={4} />
                  <ComboBox
                    values={servers}
                    valueKey="key"
                    valueName="name"
                    width="142px"
                    classes={environment}
                    environmentItem={true}
                    selectedValueId={environment}
                    onValueSelect={this.changeEnvironment}
                    tooltipMsg="Switch between Development, Testing,<br/>and Production environments"
                    tooltipId="environmentCbTooltip"
                    renderItem={(serverItem) => {
                      return (
                        <EnvironmentItem
                          serverItem={serverItem}
                          project={project}
                        />
                      );
                    }}
                  />

                  {(hasSelectedTag && !isCiCd) && (
                    <React.Fragment>
                      <div className={`project-header_version-controls ${projectMode !== ProjectViewMode.Edit && environment !== Environment.Staging && 'disabled'}`}>
                        <ProjectTagSelector environment={environment} />
                        <CreateOrSwitchToLastTagBtn
                          project={project}
                          scriptName={scriptName}
                          environment={environment}
                        />
                      </div>
                    </React.Fragment>
                  )}
                  <ProjectHeaderButton key={compareVersionsBtn.id} {...compareVersionsBtn} />
                </div>
                <div className="project-header_right">
                  <ProjectHeaderButton
                    className="small-square-btn source-code-link"
                    onClick={this.showSourceCodePopup}
                    iconClass="icon-alan-embed-code"
                  />
                  <HeaderPartSeparator
                    height={32}
                    marginLeft={0}
                    marginRight={0}
                    classes="embed-btn-sep"
                  />
                  {projectButtons.map((btn) => (
                    <ProjectHeaderButton key={btn.id} {...btn} />
                  ))}
                  {features?.project?.testMode?.enabled === true &&
                    <div
                      className={`project-header_mode-switcher ${!projectName && 'disabled'
                        }`}
                    >
                      <div
                        className={`action-btn light-blue-with-border edit-mode-switcher ${projectMode === ProjectViewMode.Edit && 'selected'
                          }`}
                        onClick={this.changeProjectModeToEdit}
                      >
                        Edit
                      </div>
                      <div
                        className={`action-btn light-blue-with-border test-mode-switcher ${projectMode !== ProjectViewMode.Edit && 'selected'
                          }`}
                        onClick={this.changeProjectModeToTest}
                      >
                        Test
                      </div>
                    </div>}
                </div>
              </div>

              {isCrawlerInspectorShown &&
                <Overlay>
                  <CrawlerInspector
                    project={project}
                    onClose={() => { this.setState({ isCrawlerInspectorShown: false }) }}
                    highlightLine={highlightLine}
                    fontSize={fontSize}
                    codeTheme={codeTheme}
                  />
                </Overlay>}
            </React.Fragment>
          </React.Fragment>
        }
        rightPart={
          <React.Fragment>
            <UserInfo hideBalanceBlock={true} />
          </React.Fragment>
        }
      />
    );
  }
}

function mapStateToProps({ projectsInfo, user, gitHubIntegration, config, scriptEditor }, ownProps) {
  const projectName = ownProps.projectName;
  const scriptName = ownProps.scriptName;
  const projects = projectsInfo.projects;

  return {
    projectId: getProjectId(projectName, projectsInfo.projects),
    project: projectsInfo.currentProject,
    projects: projects,
    tier: user.tier,
    userEmail: user.email,
    projectName,
    scriptName,
    githubDeployId: gitHubIntegration.githubDeployId,
    features: config.features,
    fontSize: scriptEditor.fontSize,
    codeTheme: scriptEditor.codeTheme,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createProjectTag: (param) => asyncDispatch(actions.addProjectTag, dispatch, param),
    openDiffModeAction: (param) => dispatch(diffModeActions.openDiffMode(param)),
    makeScriptsEditable: (project, tagId, lastTagId) => dispatch(actions.makeScriptsEditable(project, tagId, lastTagId)),
    changeProjectTestMode: (param) => dispatch(actions.changeProjectTestMode(param)),//todo: rename this action
    stopMicrophone: () => dispatch(microphoneActions.stopMicrophone()),
    highlightLine: (param) => dispatch(scriptEditorActions.highlightLine(param)),
  };
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type ProjectHeaderReduxProps = ConnectedProps<typeof connector>;

export default connector(ProjectHeader);
